export type IncludedUtilities = 'water' | 'sewage' | 'garbage' | 'electricity' | 'gas' | 'internet' | 'cable';

type UtilitiesItems = {
  [key in IncludedUtilities]: boolean | null;
};

export interface IncludedUtilitiesDto extends UtilitiesItems {
  id: string;
  isUtilitiesIncludedInRent: boolean | null;
}

export const includedUtilitiesMap = new Map<IncludedUtilities, string>([
  ['water', 'Water'],
  ['sewage', 'Sewage'],
  ['garbage', 'Garbage'],
  ['electricity', 'Electricity'],
  ['gas', 'Gas'],
  ['internet', 'Internet'],
  ['cable', 'Cable'],
]);
